<template>
    <p>404 - page not found</p>
</template>

<script>
export default {
  name: 'NotFound'
}
</script>

<style scoped>

</style>
